/**
 * This enum represents all the possible values for saved items, used in the Saved Item Dropdown and Open Item Modal.
 */

export enum SavedItemType {
    COMP_TABLE = 'SAVED_COMP_TABLE_ITEM_TYPE',
    STOCK_SCREEN = 'SAVED_STOCK_SCREEN_ITEM_TYPE',
    FUND_CHART = 'SAVED_FUND_CHART_ITEM_TYPE',
    FUND_SCREEN = 'SAVED_FUND_SCREEN_ITEM_TYPE',
    METRIC_SET = 'METRIC_SET_ITEM_TYPE',
    MODEL_PORTFOLIO = 'MODEL_PORTFOLIO_ITEM_TYPE',
    SCATTER_PLOT = 'SAVED_SCATTER_PLOT_ITEM_TYPE',
    SCORE = 'SAVED_SCORE_ITEM_TYPE',
    TECH_CHART = 'SAVED_TECH_CHART_ITEM_TYPE',
    TIMESERIES_TABLE = 'SAVED_TIMESERIES_TABLE_ITEM_TYPE',
    HYPOTHETICAL = 'SAVED_HYPOTHETICAL_ITEM_TYPE',
    ANALYSIS_PLAN = 'SAVED_ANALYSIS_PLAN_ITEM_TYPE',
    CUSTOM_PDF_REPORT = 'SAVED_CUSTOM_PDF_REPORT_ITEM_TYPE',
    PORTFOLIO_OPTIMIZER = 'SAVED_PORTFOLIO_OPTIMIZER_ITEM_TYPE',
    USER_TALKING_POINT = 'USER_TALKING_POINT_ITEM_TYPE',
}
